'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { useInstantSearch } from 'react-instantsearch';

/**
 * On client-side navigation, InstantSearchNext's TriggerSearch component does
 * not render (it only runs on the server). This leaves scheduleSearch as a noop
 * and the initial Algolia request never fires. This component detects that case
 * (no results yet, status idle) and calls refresh() which bypasses
 * scheduleSearch by calling mainHelper.search() directly.
 */
const TriggerInitialSearch = () => {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      skipSuspense: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    refresh,
    results,
    status
  } = useInstantSearch(t0);
  const triggered = useRef(false);
  let t1;
  if ($[1] !== refresh || $[2] !== results?.hits?.length || $[3] !== status) {
    t1 = () => {
      if (!triggered.current && status === "idle" && !(results?.hits?.length > 0)) {
        triggered.current = true;
        const timer = setTimeout(() => refresh(), 0);
        return () => clearTimeout(timer);
      }
    };
    $[1] = refresh;
    $[2] = results?.hits?.length;
    $[3] = status;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = results?.hits?.length;
  let t3;
  if ($[5] !== refresh || $[6] !== status || $[7] !== t2) {
    t3 = [refresh, t2, status];
    $[5] = refresh;
    $[6] = status;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useEffect(t1, t3);
  return null;
};
export default TriggerInitialSearch;